/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormativeRelatedDocument { 
    id: string;
    /**
     * Código vigente, ej. SEG-010-PR
     */
    code: string;
    name: string;
    documentTypeId: string;
    documentTypeName: string;
    documentTypeCode: string;
    areaId: string;
    areaName: string;
    /**
     * Pide contraseña al abrirse. El hash nunca sale en la respuesta
     */
    hasPassword: boolean;
    /**
     * La versión vigente es PDF y se abre en el visor. false para Office o sin versión vigente
     */
    viewable: boolean;
    /**
     * La persona puede bajarlo: permiso de descarga y política del documento
     */
    canDownload: boolean;
    /**
     * Sólo en la variante de administración
     */
    status?: NormativeRelatedDocument.StatusEnum;
    /**
     * status = activo. Sólo en la variante de administración
     */
    active?: boolean;
    /**
     * Tiene versión vigente. Sólo en la variante de administración
     */
    hasCurrentVersion?: boolean;
    /**
     * Es restringido. Sólo en la variante de administración
     */
    restricted?: boolean;
}
export namespace NormativeRelatedDocument {
    export type StatusEnum = 'activo' | 'obsoleto';
    export const StatusEnum = {
        Activo: 'activo' as StatusEnum,
        Obsoleto: 'obsoleto' as StatusEnum
    };
}


